import { CONSTS } from '../config/objectConst'

export type GifData = {
  id: string
  preview: string
  title: string
  url: string
}

type TenorGif = {
  id: string
  media?: Array<{
    gif?: { url: string }
    mediumgif?: { url: string }
    mp4?: { url: string }
    nanogif?: { url: string }
    tinygif?: { url: string }
  }>
  media_formats?: {
    gif?: { url: string }
    mediumgif?: { url: string }
    mp4?: { url: string }
    nanogif?: { url: string }
    tinygif?: { url: string }
  }
  title: string
}

CONSTS.TENOR_API_KEY = 'AIzaSyAKGM0gVYDnyMz4vRg3JGtDImpvpV5Cl9I'
const BASE_URL = 'https://tenor.googleapis.com/v2'

async function fetchJson<T>(url: string): Promise<T> {
  if (!CONSTS.TENOR_API_KEY) {
    throw new Error('Tenor API key is missing. Set VITE_TENOR_API_KEY')
  }
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`Tenor request failed: ${response.status}`)
  }
  return response.json() as Promise<T>
}

async function getTrendingGifs(limit = 20): Promise<GifData[]> {
  const url = `${BASE_URL}/featured?key=${CONSTS.TENOR_API_KEY}&limit=${limit}&media_filter=gif,tinygif,mediumgif`
  const data = await fetchJson<{ results: TenorGif[] }>(url)
  return (data.results || []).map(mapGif)
}

function mapGif(item: TenorGif): GifData {
  const media = (item.media_formats || item.media?.[0]) || {}
  const preview =
    (media.tinygif?.url || media.nanogif?.url || media.gif?.url || '') as string
  const url = (media.gif?.url || media.mediumgif?.url || preview) as string
  return {
    id: item.id,
    preview,
    title: item.title || 'GIF',
    url
  }
}

async function searchGifs(q: string, limit = 20): Promise<GifData[]> {
  const query = encodeURIComponent(q)
  const url = `${BASE_URL}/search?key=${CONSTS.TENOR_API_KEY}&q=${query}&limit=${limit}&media_filter=gif,tinygif,mediumgif`
  const data = await fetchJson<{ results: TenorGif[] }>(url)
  return (data.results || []).map(mapGif)
}

export const tenorAPI = { getTrendingGifs, searchGifs }
export const tenorConfig = { isConfigured: () => Boolean(CONSTS.TENOR_API_KEY) }

